import React from 'react';

import DropdownInlineMenu from 'onboarding/common/DropdownInlineMenu';

// FIXME: remove this component and use DropdownInlineMenu directly
export const DropdownInline = ({ selections }) => <DropdownInlineMenu selections={selections} />;

export default DropdownInline;
